<template>

  <div class="quiz__footer">
    <div class="dne dne-desktop">
      <div class="dne__title">
        {{ translate.masterFooterDne }}
      </div>
      <div class="dne__types ">
        <div class="dne__type dne__type--red masterType" data-balloon-length="medium" data-balloon-pos="up">
        <span class="aria-label">{{ translate.masterTypeLabel }}</span>
        {{typeParam}}</div>
        <div class="dne__type dne__type--orange masterLong" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterLongLabel }}</span>
          {{ showLong && longParam ? ('000'+longParam).slice(-3) : '' }}</div>
        <div class="dne__type dne__type--green-light masterThread" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterThreadLabel }}</span>
          {{threadParam}}</div>
        <div class="dne__type dne__type--green masterVoltage" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterVoltageLabel }}</span>
          {{voltageParam}}</div>
        <div class="dne__type dne__type--blue masterBody" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterBodyLabel }}</span>
          {{bodyParam}}</div>
        <div class="dne__type dne__type--indigo-light masterBracing" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterBracingLabel }}</span>
          {{bracingParam}}</div>
        <div class="dne__type dne__type--indigo masterCargo" data-balloon-length="medium" data-balloon-pos="up">
          <span class="aria-label">{{ translate.masterCargoLabel }}</span>
          {{cargoParam}}</div>
      </div>
    </div>

    <div class="dne-mobile">
        <div v-if="typeParam">
            <span>{{ translate.masterTypeLabel }}</span>:<span class="d-val">{{typeParam}}</span>
        </div>
      <div v-if="showLong && longParam">
        <span>{{ translate.masterLongLabel }}</span>:<span class="d-val">{{ showLong && longParam ? ('000'+longParam).slice(-3) : '' }}</span>
      </div>
      <div v-if="threadParam">
        <span>{{ translate.masterThreadLabel }}</span>:<span class="d-val">{{threadParam}}</span>
      </div>
      <div v-if="voltageParam">
        <span>{{ translate.masterVoltageLabel }}</span>:<span class="d-val">{{voltageParam}}</span>
      </div>
      <div v-if="bodyParam">
        <span>{{ translate.masterBodyLabel }}</span>:<span class="d-val">{{bodyParam}}</span>
      </div>
      <div v-if="bracingParam">
        <span>{{ translate.masterBracingLabel }}</span>:<span class="d-val">{{bracingParam}}</span>
      </div>
      <div v-if="cargoParam">
        <span>{{ translate.masterCargoLabel }}</span>:<span class="d-val">{{cargoParam}}</span>
      </div>
    </div>
    <div class="quiz__btns">

      <a class="btn btn--green-light btn-download" v-if="download" target="_blank" :href="download">{{ translate.masterDownload }}</a>

      <button class="btn btn--green" :disabled="!canNext" v-if="step == lastStep" @click="showResult" >{{ translate.masterSubmit }}</button>

      <button class="btn btn--green go-next-step" :disabled="!canNext" v-if="step < lastStep" @click="nextStep" type="button" >{{ translate.masterNextStep }}</button>

    </div>
  </div>

</template>

<script>
import {default as axios} from "axios";
import config from "../config";
import qs from "querystring";

export default {
  name: "Marking",
  props: [
      'translate',
      'step',
      'typeParam',
      'longParam',
      'threadParam',
      'voltageParam',
      'bodyParam',
      'bracingParam',
      'cargoParam',
      'canNext',
      'download',
      'lastStep'
  ],
  data(){
      return{
          showLong: false
      }
  },
  methods:{
    nextStep(){
        this.$emit('nextStep');
    },
    showResult(){

      let marking = 'ДНЕ-' + this.typeParam + ('000'+this.longParam).slice(-3) + '-' + this.threadParam + this.voltageParam + this.bodyParam + this.bracingParam + this.cargoParam;

      axios
          .post(config.findSensorUrl,qs.stringify({
            marking: marking
          }))
          .then((response) => {
            if (response.data) {
              window.location = response.data;
            } else {
              alert('Не удалось найти, попробуйте воспользоваться фильтром.')
            }
          })
          .catch((error) => {
            alert('Не удалось найти, попробуйте воспользоваться фильтром.')
            console.log(error);
          });

    }
  },
  watch:{
    longParam(){
      this.showLong = true
    }
  }
}
</script>

<style scoped>

  .dne__type{
    position: relative;
  }

  .dne__type:before {
    width: 0;
    height: 0;

    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #343b4c;
    padding-top: 6px;

    opacity: 0;
    pointer-events: none;

    content: "";
    position: absolute;
    z-index: 10;
  }

  .dne__type:hover:before{
    -webkit-transform: translate(-50%,0);
    -ms-transform: translate(-50%,0);
    transform: translate(-50%,0);
    left: 50%;

    -webkit-transition: all .18s ease-out .18s;
    -o-transition: all .18s ease-out .18s;
    transition: all .18s ease-out .18s;

    bottom: 100%;
    opacity: 1;
    pointer-events: none;
  }

  .aria-label{
    width: 220px;
    white-space: normal;
    margin-bottom: 10px;
    background-color: #343b4c;
    font-size: .97222vw;
    border-radius: 1.04167vw;
    padding: 1.04167vw;
    text-align: center;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: all .18s ease-out .18s;
    -o-transition: all .18s ease-out .18s;
    transition: all .18s ease-out .18s;
    text-indent: 0;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
    font-weight: 400;
    font-style: normal;
    text-shadow: none;
    z-index: 10;
    position: absolute;
    bottom: 100%;
  }
  .dne__type:hover .aria-label{
    opacity: 1;
  }

  .btn-download{
    text-decoration: none;
  }

  button:disabled,
  button[disabled]{
      background-color: #009b7a6b;
  }

  .dne-mobile{
    display: none;
    background-color: rgba(0,155,122,.02);
    font-size: 4.04167vw;
    font-weight: 500;
    color: #009b7a;
    padding: 0.5rem 1rem;
    margin-bottom: 1rem;
  }

  .d-val{
    font-weight: 500;
    color: #5a6c7d;
    margin-left: 0.3rem;
  }

  @media (max-width: 1024px) {
    .dne-desktop{
      display: none;
    }
    .quiz__btns .btn {
        padding-left: 9.375vmin;
        padding-right: 9.375vmin;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 3.125vmin;
        border-radius: 11.25vmin;
        font-size: 4.125vmin;
        min-width: 40.625vmin;
        height: 16.875vmin;
    }
    .dne-mobile{
      display: block;
    }
  }


</style>